"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-seventeen/section/blogSection.tsx */

import { SmartImage } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSectionBlogSeventeenFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/blog/wellness-blog-01.jpg" | "/Templates/Doccure/img/blog/wellness-blog-02.jpg" | "/Templates/Doccure/img/blog/wellness-blog-03.jpg" */
    src: string;
    /** Detected variants: "31" | "01" | "02" */
    div0Text: ReactNode;
    /** Detected variants: "May" | "Apr" | "Mar" */
    span0Text: ReactNode;
    /** Detected variants: "Mindfulness Practice" | "Yoga & Movement" | "Stress Management" */
    a0Text: ReactNode;
    /** Detected variants: "Living in the Now: Cultivating mindfulness to enhance your journey" | "Embodying Grace: Moving with purpose and intention to foster balance and inner peace" | "Revitalizing Inner Health: Embrace nourishing foods that support your body's natural healing" */
    a0A0Text: ReactNode;
    /** Detected variants: "Gentle breaths and grounded awareness open pathways to tranquility, inviting calm amidst the chaos." | "Each stretch and pose cultivates balance and strength, harmonizing body and mind in a sacred dance." | "Vibrant meals crafted with care awaken vitality and support healing, fueling a journey towards well-being." */
    p0Text: ReactNode;
    /** Detected variants: "blog-item-seventeen wow fadeInUp" */
    className?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "Mindfulness Practice" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-img" */
    div0ClassName?: string;
    /** Detected variants: "blog-date" */
    div0ClassName2?: string;
    /** Detected variants: "badge" */
    a0ClassName?: string;
    /** Detected variants: "#" */
    a0Href?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "#" */
    a0Href2?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
};
export type HomeSeventeenBlogSectionGeneratedProps = {
    divDiv0A0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSectionBlogSeventeenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSectionBlogSeventeenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Latest Blogs & Articles" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "We identify and address root causes through a comprehensive mind-body-spirit approach." */
    sectionDiv0Div0P0PText?: ReactNode;
    sectionDiv0Div1ClassName?: string;
    /** Default: "bg" */
    sectionDiv0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shape-01.png" */
    sectionDiv0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionDiv0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/blog-bg-04.png" */
    sectionDiv0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    blogSectionBlogSeventeenFadeInUps: BlogSectionBlogSeventeenFadeInUpsItem[];
    blogSectionBlogSeventeenFadeInUpsItemWrapper?: (item: BlogSectionBlogSeventeenFadeInUpsItem, content: ReactNode) => ReactNode;
    blogSectionBlogSeventeenFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSectionBlogSeventeenFadeInUpsImageVisible?: boolean;
    blogSectionBlogSeventeenFadeInUpsImageRenderer?: (item: BlogSectionBlogSeventeenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    blogSectionBlogSeventeenFadeInUpsH3Visible?: boolean;
    blogSectionBlogSeventeenFadeInUpsH3Renderer?: (item: BlogSectionBlogSeventeenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    blogSectionBlogSeventeenFadeInUpsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSectionBlogSeventeenFadeInUpsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSectionBlogSeventeenFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSectionBlogSeventeenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
};

const HomeSeventeenBlogSectionGenerated: FC<HomeSeventeenBlogSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Latest Blogs & Articles",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0P0PText = "We identify and address root causes through a comprehensive mind-body-spirit approach.",
    sectionDiv0ImageWithBasePath0ImageAlt = "bg",
    sectionDiv0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/shape-01.png",
    sectionDiv0ImageWithBasePath0ImageVisible,
    sectionDiv0ImageWithBasePath0ImageRenderer,
    sectionDiv0ImageWithBasePath0ImageProps,
    sectionDiv0ImageWithBasePath1ImageAlt = "bg",
    sectionDiv0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/blog-bg-04.png",
    sectionDiv0ImageWithBasePath1ImageVisible,
    sectionDiv0ImageWithBasePath1ImageRenderer,
    sectionDiv0ImageWithBasePath1ImageProps,
    divDiv0A0ImageWithBasePath0ImageProps,
    divDiv1H30H3Props,
    sectionDiv0Div1ClassName,
    blogSectionBlogSeventeenFadeInUps,
    blogSectionBlogSeventeenFadeInUpsItemWrapper,
    blogSectionBlogSeventeenFadeInUpsRenderer,
    blogSectionBlogSeventeenFadeInUpsImageVisible,
    blogSectionBlogSeventeenFadeInUpsImageRenderer,
    blogSectionBlogSeventeenFadeInUpsH3Visible,
    blogSectionBlogSeventeenFadeInUpsH3Renderer,
    blogSectionBlogSeventeenFadeInUpsImageProps,
    blogSectionBlogSeventeenFadeInUpsH3Props,
}) => {
    return (
        <section className="blog-section-seventeen section">
            <div className="container">
                <div className="section-header section-header-seventeen text-center wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title text-gradient" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    <p className="description">{sectionDiv0Div0P0PText}</p>
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    <div className="col-xl-10 mx-auto">
                        {renderCollectionNode(
                            blogSectionBlogSeventeenFadeInUps,
                            (item: BlogSectionBlogSeventeenFadeInUpsItem) => (
                                <div className={item.className ?? "blog-item-seventeen wow fadeInUp"} data-wow-duration={item.dataWowDuration} key={item.key}>
                                    <div className={item.div0ClassName ?? "blog-img"}>
                                        <a href={item.href ?? "#"}>
                                            {renderItemNode(blogSectionBlogSeventeenFadeInUpsImageVisible, blogSectionBlogSeventeenFadeInUpsImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "Mindfulness Practice"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof blogSectionBlogSeventeenFadeInUpsImageProps === "function" ? blogSectionBlogSeventeenFadeInUpsImageProps(item) : (blogSectionBlogSeventeenFadeInUpsImageProps ?? {}))} {...(typeof divDiv0A0ImageWithBasePath0ImageProps === "function" ? divDiv0A0ImageWithBasePath0ImageProps(item) : (divDiv0A0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </a>
                                        <div className={item.div0ClassName2 ?? "blog-date"}>
                                            <span>{item.span0Text}</span>
                                            {item.div0Text}
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        <a href={item.a0Href ?? "#"} className={item.a0ClassName ?? "badge"}>{item.a0Text}</a>
                                        {renderItemNode(blogSectionBlogSeventeenFadeInUpsH3Visible, blogSectionBlogSeventeenFadeInUpsH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSectionBlogSeventeenFadeInUpsH3Props === "function" ? blogSectionBlogSeventeenFadeInUpsH3Props(item) : (blogSectionBlogSeventeenFadeInUpsH3Props ?? {}))} {...(typeof divDiv1H30H3Props === "function" ? divDiv1H30H3Props(item) : (divDiv1H30H3Props ?? {}))}>
                                                <a href={item.a0Href2 ?? "#"}>{item.a0A0Text}</a>
                                            </h3>
                                        ))}
                                        <p>{item.p0Text}</p>
                                    </div>
                                </div>
                            ),
                            blogSectionBlogSeventeenFadeInUpsItemWrapper,
                            blogSectionBlogSeventeenFadeInUpsRenderer
                        )}
                    </div>
                </div>
                {renderNode(sectionDiv0ImageWithBasePath0ImageVisible, sectionDiv0ImageWithBasePath0ImageRenderer, (
                    <SmartImage src={sectionDiv0ImageWithBasePath0ImageSrc} alt={sectionDiv0ImageWithBasePath0ImageAlt} className="blog-bg-01 rotate-anime" {...(sectionDiv0ImageWithBasePath0ImageProps ?? {})} />
                ))}
                {renderNode(sectionDiv0ImageWithBasePath1ImageVisible, sectionDiv0ImageWithBasePath1ImageRenderer, (
                    <SmartImage src={sectionDiv0ImageWithBasePath1ImageSrc} alt={sectionDiv0ImageWithBasePath1ImageAlt} className="blog-bg-02" {...(sectionDiv0ImageWithBasePath1ImageProps ?? {})} />
                ))}
            </div>
        </section>
    );
};

export default HomeSeventeenBlogSectionGenerated;
